<template>
  <qc-container title="财务管理">
    <page-request @load="loadData" ref="table" url="/api/mgr/business/shop/money/info/list" :table-header="tableHeader" :expend="expend"
                  :prop="{goodsType:0,orgId:orgId}" :op-width="200">
      <div v-if="totalRecord > 0">
        共{{totalRecord}}笔 | 收入{{moneyLogSum.incomeMoney.toFixed(2)}}元   支出{{moneyLogSum.outMoney.toFixed(2)}}元   待入账金额{{moneyLogSum.waitMoney.toFixed(2)}}元
        <template v-if="showDepositMoney">
          <span class="messageAlert">现锁定押金{{moneyLogSum.depositMoney.toFixed(2)}}元</span>
          <span class="messageAlert">已退款押金{{moneyLogSum.refundDepositMoney.toFixed(2)}}元</span>
        </template>
      </div>
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";

export default {
  props:{
    orgId:{
      type:String
    },
    showDepositMoney:{
      type:Boolean,
      default: false
    }
  },
  name: "org-finance-list",
  components: {PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {prop: "createTime", label: "发生日期",width:160},
        {prop: "money", label: "收支金额",width:160},
        {prop: "remainder", label: "总余额",width:160},
        {label: "类型",renderDraw:row=>{return row.salesType==0?"收入":"支出";},width: 100},
        {prop: "code", label: "流水号",width:200},
        {prop: "refCode", label: "关联订单",width:200},
        {prop: "typeDesc", label: "说明"}
      ],
      expend: [
        {label: "发生日期", start: "startTime", end: "endTime", type: "daterange"},
        {label: "类型", prop: "salesType",type:"select",options:[{"label":"收入","value":"0"},{"label":"支出","value":"1"}]},
        {label: "关联订单", prop: "refCode"},
      ],
      moneyLogSum:{incomeMoney:0,outMoney:0,waitMoney:0,depositMoney:0,refundDepositMoney:0},
      totalRecord:0
    }
  },
  mixins: [tableBase],
  methods: {
    loadData(searchObj,data){
      console.log("=============查询条件================")
      console.log(searchObj,data);

      this.totalRecord = data.totalRecord;
      this.findMoneyLogSum(searchObj);
    },
    findMoneyLogSum(searchObj){
      this.simpleGet("/api/mgr/business/shop/money/info/moneyLogSum", searchObj, result => {
        this.moneyLogSum = result.data;
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
